(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("iframe-resizer"));
	else if(typeof define === 'function' && define.amd)
		define(["iframe-resizer"], factory);
	else if(typeof exports === 'object')
		exports["MyPOSEmbedded"] = factory(require("iframe-resizer"));
	else
		root["MyPOSEmbedded"] = factory(root["iframe-resizer"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__31__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 59);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(11)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(5);
var hide = __webpack_require__(17);
var redefine = __webpack_require__(37);
var ctx = __webpack_require__(39);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(42);
var defined = __webpack_require__(24);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(24);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(19);
var toPrimitive = __webpack_require__(7);
var dP = Object.defineProperty;

exports.f = __webpack_require__(0) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(22) || !__webpack_require__(11)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(2)[K];
});


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(28);
var createDesc = __webpack_require__(12);
var toIObject = __webpack_require__(3);
var toPrimitive = __webpack_require__(7);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(19);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(0) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(56);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(12);
module.exports = __webpack_require__(0) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(0) && !__webpack_require__(11)(function () {
  return Object.defineProperty(__webpack_require__(36)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(22) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(3);
var arrayIndexOf = __webpack_require__(44)(false);
var IE_PROTO = __webpack_require__(26)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(21)('keys');
var uid = __webpack_require__(20);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 28 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(0);
var getKeys = __webpack_require__(50);
var toIObject = __webpack_require__(3);
var isEnum = __webpack_require__(28).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(4);
var IE_PROTO = __webpack_require__(26)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__31__;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(58);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35);
__webpack_require__(49);
__webpack_require__(51);
__webpack_require__(52);
__webpack_require__(53);
__webpack_require__(54);
__webpack_require__(55);
module.exports = __webpack_require__(5).Object;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(40);
var toIObject = __webpack_require__(3);
var gOPD = __webpack_require__(14);
var createProperty = __webpack_require__(48);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var hide = __webpack_require__(17);
var has = __webpack_require__(8);
var SRC = __webpack_require__(20)('src');
var $toString = __webpack_require__(38);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(5).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21)('native-function-to-string', Function.toString);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(13);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(41);
var gOPS = __webpack_require__(47);
var anObject = __webpack_require__(18);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(23);
var hiddenKeys = __webpack_require__(27).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(43);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(3);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(46);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(25);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(25);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(12);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(29)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(23);
var enumBugKeys = __webpack_require__(27);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(29)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(4);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(6);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(0) && $export($export.P + __webpack_require__(9), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(4);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(6);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(0) && $export($export.P + __webpack_require__(9), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(14).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(0) && $export($export.P + __webpack_require__(9), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(30);
var getOwnPropertyDescriptor = __webpack_require__(14).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(0) && $export($export.P + __webpack_require__(9), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(32);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "*,\r\n:after,\r\n:before {\r\n    box-sizing: border-box\r\n}\r\n\r\n:focus {\r\n    outline: none\r\n}\r\n\r\nhtml {\r\n    font-size: 14px\r\n}\r\n\r\nbody {\r\n    padding: 0;\r\n    margin: 0;\r\n    font-family: Arial, sans-serif;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n    width: 100%;\r\n    position: relative;\r\n}\r\n\r\n.threedsModal-container {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0\r\n}\r\n.threedsModal-container {\r\n    opacity: 0;\r\n    -webkit-transform: scale(.95);\r\n    -ms-transform: scale(.95);\r\n    transform: scale(.95);\r\n    -webkit-transform-origin: bottom center;\r\n    -ms-transform-origin: bottom center;\r\n    transform-origin: bottom center;\r\n    transition: opacity .2s ease-in-out, -webkit-transform .2s ease-in;\r\n    transition: opacity .2s ease-in-out, transform .2s ease-in;\r\n    transition: opacity .2s ease-in-out, transform .2s ease-in, -webkit-transform .2s ease-in\r\n}\r\n\r\n.threedsModal-open .threedsModal-container {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    transform: scale(1);\r\n    transition: opacity .35s ease-in-out, -webkit-transform .35s ease-out;\r\n    transition: opacity .35s ease-in-out, transform .35s ease-out;\r\n    transition: opacity .35s ease-in-out, transform .35s ease-out, -webkit-transform .35s ease-out;\r\n    transition-delay: .1s\r\n}\r\n\r\n.threedsModal-header {\r\n    height: 40px;\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-pack: end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: end;\r\n    justify-content: flex-end;\r\n    text-shadow: 1px 1px 5px rgba(0, 0, 0, .5)\r\n}\r\n\r\n.threedsModal-body {\r\n    height: calc(100% - 60px);\r\n    width: 100%;\r\n    background: white;\r\n    overflow: hidden;\r\n    box-shadow: 0 7px 32px rgba(0, 0, 0, .15), 0 3px 6px rgba(0, 0, 0, .2)\r\n}\r\n\r\n.threedsModal-body,\r\n.threedsModal-content,\r\n.threedsModal-content * {\r\n    border-radius: 4px\r\n}\r\n\r\n.threedsModal-cancel {\r\n    font-family: Arial, sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    background: transparent;\r\n    border: 0;\r\n    color: #d2d2d2;\r\n    font-weight: 600;\r\n    margin-right: -3px;\r\n    font-size: 30px;\r\n    line-height: 1;\r\n    cursor: pointer;\r\n    text-transform: uppercase;\r\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, .3);\r\n    -webkit-transform: opacity .3s ease;\r\n    -ms-transform: opacity .3s ease;\r\n    transform: opacity .3s ease;\r\n    letter-spacing: .1px\r\n}\r\n\r\n.threedsModal-cancel:active,\r\n.threedsModal-cancel:hover {\r\n    color: white\r\n}\r\n\r\n.threedsModal-cancel:disabled {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    cursor: default\r\n}\r\n\r\n.threedsModal-content {\r\n    height: 100%;\r\n    position: relative\r\n}\r\n\r\n.threedsModal {\r\n    position: absolute;\r\n    width: 100%;\r\n    max-height: 100%;\r\n    bottom: 0;\r\n    height: calc(57vh + 370px)\r\n}\r\n\r\n.threedsModal-position {\r\n    position: relative;\r\n    width: 100%;\r\n    max-height: 100%\r\n}\r\n\r\n.threedsModal .threedsModal-position {\r\n    height: 700px\r\n}\r\n\r\n.threedsModal-size {\r\n    position: relative;\r\n    max-height: 100%;\r\n    max-width: calc(100% - 20px);\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%)\r\n}\r\n.threedsModal .threedsModal-size {\r\n    width: 400px;\r\n    height: 660px\r\n}\r\n\r\n.threedsModal-content-inner,\r\niframe {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100% !important;\r\n    width: 100%;\r\n}\r\n.threedsModal-content-inner {\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.loading-wrapper {\r\n    text-align: center;\r\n    margin: 20px auto 30px;\r\n}\r\n.loading-wrapper img {\r\n    width: 77px;\r\n    height: 77px;\r\n    margin: 20px auto 30px;\r\n}\r\n.loading-wrapper .loading-title {\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    line-height: 1.38;\r\n    color: rgb(40, 57, 83);\r\n    margin-bottom: 10px;\r\n    font-family: Arial, sans-serif;\r\n}\r\n.loading-wrapper .loading-desc {\r\n    font-size: 13px;\r\n    line-height: 1.38;\r\n    color: rgb(40, 57, 83);\r\n    margin-bottom: 10px;\r\n    font-family: Arial, sans-serif;\r\n}\r\n@media (max-width:420px) {\r\n    .threedsModal .threedsModal-position,\r\n    .threedsModal .threedsModal-size,\r\n    .threedsModal.threedsModal {\r\n        height: 100%;\r\n        width: 100%\r\n    }\r\n\r\n    .threedsModal .threedsModal-body {\r\n        height: calc(100% - 55px)\r\n    }\r\n\r\n    .threedsModal .threedsModal-cancel {\r\n        text-shadow: none\r\n    }\r\n\r\n    .threedsModal .threedsModal-body,\r\n    .threedsModal .threedsModal-content,\r\n    .threedsModal .threedsModal-content * {\r\n        border-radius: 8px\r\n    }\r\n}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./applePay": 33,
	"./applePay.css": 33,
	"./iFrameModalStyles": 16,
	"./iFrameModalStyles.css": 16
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(32);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "/* Apple Pay Button */\r\n.apple-pay-button {\r\n    width: 100%;\r\n    height: 40px;\r\n    display: inline-block;\r\n    -webkit-appearance: -apple-pay-button;\r\n    cursor: pointer;\r\n}\r\n\r\n.apple-pay-button-black-with-text {\r\n    -apple-pay-button-style: black;\r\n}\r\n\r\n.apple-pay-button-white-with-text {\r\n    -apple-pay-button-style: white;\r\n}\r\n\r\n.apple-pay-button-white-with-line-with-text {\r\n    -apple-pay-button-style: white-outline;\r\n}\r\n\r\n.apple-pay-button-text-book {\r\n    -apple-pay-button-type: book;\r\n}\r\n\r\n.apple-pay-button-text-plain {\r\n    -apple-pay-button-type: plain;\r\n}\r\n\r\n.apple-pay-button-text-setup {\r\n    -apple-pay-button-type: set-up;\r\n}\r\n\r\n.apple-pay-button-text-buy {\r\n    -apple-pay-button-type: buy;\r\n}\r\n\r\n.apple-pay-button-text-check-out {\r\n    -apple-pay-button-type: check-out;\r\n}\r\n\r\n.apple-pay-button-text-donate {\r\n    -apple-pay-button-type: donate;\r\n}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "createPayment", function() { return /* binding */ createPayment; });
__webpack_require__.d(__webpack_exports__, "createPaymentForm", function() { return /* binding */ createPaymentForm; });
__webpack_require__.d(__webpack_exports__, "createPreAuthorization", function() { return /* binding */ createPreAuthorization; });
__webpack_require__.d(__webpack_exports__, "createPreAuthorizationForm", function() { return /* binding */ createPreAuthorizationForm; });
__webpack_require__.d(__webpack_exports__, "createSelfCheckoutPayment", function() { return /* binding */ createSelfCheckoutPayment; });
__webpack_require__.d(__webpack_exports__, "createApplePayButton", function() { return /* binding */ createApplePayButton; });
__webpack_require__.d(__webpack_exports__, "createGooglePayButton", function() { return /* binding */ createGooglePayButton; });
__webpack_require__.d(__webpack_exports__, "IS_APPLE_PAY_AVAILABLE", function() { return /* binding */ IS_APPLE_PAY_AVAILABLE; });
__webpack_require__.d(__webpack_exports__, "IPC_URL", function() { return /* binding */ IPC_URL; });

// EXTERNAL MODULE: ./node_modules/core-js/es7/object.js
var object = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(15);

// CONCATENATED MODULE: ./src/img/loader.gif
/* harmony default export */ var loader = ("data:image/gif;base64,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");
// CONCATENATED MODULE: ./src/jsx.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _jsxCreateElement = function _jsxCreateElement(tagName) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var elem = _extends(document.createElement(tagName), attrs);

  if (attrs !== undefined && attrs !== null && attrs.style !== undefined) {
    elem.setAttribute('style', attrs.style);
  }

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var _loop = function _loop() {
    var child = _children[_i];

    if (Array.isArray(child)) {
      child.map(function (item) {
        elem.appendChild(typeof child === 'string' ? document.createTextNode(item) : item);
      });
    } else {
      elem.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    }
  };

  for (var _i = 0, _children = children; _i < _children.length; _i++) {
    _loop();
  }

  return elem;
};
// CONCATENATED MODULE: ./src/modules/classes/Loader.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }




var Loader_loaderImgClass = function () {
  function loaderImgClass() {
    _classCallCheck(this, loaderImgClass);
  }

  _createClass(loaderImgClass, [{
    key: "generate",
    value: function generate() {
      var uniqueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return _jsxCreateElement("div", {
        id: "myposCheckoutLoadingComponent".concat(uniqueId),
        style: "text-align: center !important; margin-left: auto !important; margin-right: auto !important; padding-top: 20px !important; padding-bottom: 30px !important; background-color: #ffffff !important;display: flex; justify-content: center; flex-direction: column; height: calc(100% - 50px);"
      }, _jsxCreateElement("img", {
        src: loader,
        style: "width: 77px !important; height: 77px !important; margin: 20px auto 30px !important;"
      }), _jsxCreateElement("p", {
        style: "font-size: 18px !important; font-weight: 700 !important; line-height: 1.38 !important; color: rgb(40, 57, 83) !important; margin-bottom: 10px !important; font-family: Arial, sans-serif !important;"
      }, "Loading..."), _jsxCreateElement("p", {
        style: "font-size: 13px !important; line-height: 1.38 !important; color: rgb(40, 57, 83) !important; margin-bottom: 10px !important; font-family: Arial, sans-serif !important;"
      }, "Checkout is being loaded. Please wait."));
    }
  }]);

  return loaderImgClass;
}();

var loaderImg = new Loader_loaderImgClass();
// CONCATENATED MODULE: ./src/modules/classes/IframeGenerator.js
function IframeGenerator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IframeGenerator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function IframeGenerator_createClass(Constructor, protoProps, staticProps) { if (protoProps) IframeGenerator_defineProperties(Constructor.prototype, protoProps); if (staticProps) IframeGenerator_defineProperties(Constructor, staticProps); return Constructor; }



var IframeGenerator_IframeGeneratorClass = function () {
  function IframeGeneratorClass() {
    IframeGenerator_classCallCheck(this, IframeGeneratorClass);
  }

  IframeGenerator_createClass(IframeGeneratorClass, [{
    key: "generate",
    value: function generate() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '692';

      var iframe = _jsxCreateElement("iframe", {
        name: "IPCIFrame".concat(uniqueId),
        id: "IPCIFrame".concat(uniqueId),
        style: "display:none;border:none;overflow:hidden;height:".concat(height, "px;"),
        allowpaymentrequest: true,
        role: "presentation",
        allow: "payment *",
        width: "100%",
        scrolling: "no"
      });

      if (url) {
        iframe.setAttribute('src', url);
      }

      iframe.setAttribute('allowpaymentrequest', '1');
      return iframe;
    }
  }]);

  return IframeGeneratorClass;
}();

var IframeGenerator = new IframeGenerator_IframeGeneratorClass();
// EXTERNAL MODULE: external "iframe-resizer"
var external_iframe_resizer_ = __webpack_require__(31);

// CONCATENATED MODULE: ./src/modules/classes/FormGenerator.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FormGenerator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function FormGenerator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function FormGenerator_createClass(Constructor, protoProps, staticProps) { if (protoProps) FormGenerator_defineProperties(Constructor.prototype, protoProps); if (staticProps) FormGenerator_defineProperties(Constructor, staticProps); return Constructor; }


var FormGenerator_FormGenerator = function () {
  function FormGenerator() {
    FormGenerator_classCallCheck(this, FormGenerator);

    this._properties = {};
    this._defaultProperties = {};
    this._mandatoryProperties = {};
    this._action = '';
    this._target = '';
    this._name = '';
    this._id = '';
  }

  FormGenerator_createClass(FormGenerator, [{
    key: "setProperties",
    value: function setProperties(properties) {
      this._properties = properties;
    }
  }, {
    key: "setDefaultProperties",
    value: function setDefaultProperties(defaultProperties) {
      this._defaultProperties = defaultProperties;
    }
  }, {
    key: "setMandatoryProperties",
    value: function setMandatoryProperties(mandatoryProperties) {
      this._mandatoryProperties = mandatoryProperties;
    }
  }, {
    key: "getProperties",
    value: function getProperties() {
      return this._properties;
    }
  }, {
    key: "getDefaultProperties",
    value: function getDefaultProperties() {
      return this._defaultProperties;
    }
  }, {
    key: "getMandatoryProperties",
    value: function getMandatoryProperties() {
      return this._mandatoryProperties;
    }
  }, {
    key: "getAction",
    value: function getAction() {
      return this._action;
    }
  }, {
    key: "setAction",
    value: function setAction(value) {
      this._action = value;
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      return this._target;
    }
  }, {
    key: "setTarget",
    value: function setTarget(value) {
      this._target = value;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "setName",
    value: function setName(value) {
      this._name = value;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "setId",
    value: function setId(value) {
      this._id = value;
    }
  }, {
    key: "generate",
    value: function generate() {
      var data = _objectSpread(_objectSpread(_objectSpread({}, this.getDefaultProperties()), this.getProperties()), this.getMandatoryProperties());

      return _jsxCreateElement("form", {
        method: "POST",
        action: this.getAction(),
        target: this.getTarget(),
        name: this.getName(),
        id: this.getId(),
        style: "display:none;"
      }, Object.entries(data).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _jsxCreateElement("input", {
          type: "hidden",
          name: key,
          value: value
        });
      }));
    }
  }]);

  return FormGenerator;
}();
// CONCATENATED MODULE: ./src/modules/classes/IframeModalGenerator.js
function IframeModalGenerator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IframeModalGenerator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function IframeModalGenerator_createClass(Constructor, protoProps, staticProps) { if (protoProps) IframeModalGenerator_defineProperties(Constructor.prototype, protoProps); if (staticProps) IframeModalGenerator_defineProperties(Constructor, staticProps); return Constructor; }






var IframeModalGenerator_IframeModalGeneratorClass = function () {
  function IframeModalGeneratorClass() {
    IframeModalGenerator_classCallCheck(this, IframeModalGeneratorClass);
  }

  IframeModalGenerator_createClass(IframeModalGeneratorClass, [{
    key: "_iframeContent",
    value: function _iframeContent() {
      return _jsxCreateElement("div", {
        className: "threedsModal threedsModal-open"
      }, _jsxCreateElement("div", {
        className: "threedsModal-position"
      }, _jsxCreateElement("div", {
        className: "threedsModal-size"
      }, _jsxCreateElement("div", {
        className: "threedsModal-container"
      }, _jsxCreateElement("div", {
        className: "threedsModal-header"
      }, _jsxCreateElement("button", {
        id: "myposCheckoutModalClose",
        type: "button",
        className: "threedsModal-cancel"
      }, "\xD7")), _jsxCreateElement("div", {
        className: "threedsModal-body"
      }, _jsxCreateElement("div", {
        className: "threedsModal-content"
      }, _jsxCreateElement("div", {
        className: "threedsModal-content-inner"
      }, _jsxCreateElement("iframe", {
        name: "3DSIframeInner",
        id: "3DSIframeInner",
        style: "border:none;",
        width: "100%",
        height: "100%",
        scrolling: "auto"
      }))))))));
    }
  }, {
    key: "closeAction",
    value: function closeAction() {
      var element = document.getElementById('myposCheckoutThreedsModalBackdrop');
      element.parentNode.removeChild(element);
      document.getElementsByTagName("body")[0].style.removeProperty("overflow");
      document.getElementsByTagName("body")[0].style.removeProperty("padding-right");
    }
  }, {
    key: "generateBackdropIframe",
    value: function generateBackdropIframe() {
      var modalBackdrop = _jsxCreateElement("div", {
        id: "myposCheckoutThreedsModalBackdrop",
        style: "display: block !important; position: fixed !important; z-index: 2147483647 !important; background: rgba(40, 40, 40, 0.75) !important; transition: background 400ms ease 0s !important; will-change: background !important; top: 0px !important; left: 0px !important; right: 0px !important; bottom: 0px !important;"
      }, _jsxCreateElement("iframe", {
        name: "3DSIframe",
        id: "3DSIframe",
        style: "border:none;",
        width: "100%",
        height: "100%"
      }));

      document.body.appendChild(modalBackdrop);
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '17px';
    }
  }, {
    key: "generateModalBackDropContent",
    value: function generateModalBackDropContent() {
      var iframe = document.getElementById("3DSIframe");
      iframe.contentDocument.head.appendChild(_jsxCreateElement("style", null, __webpack_require__(16).toString()));
      iframe.contentDocument.body.appendChild(this._iframeContent());
    }
  }, {
    key: "generateResize",
    value: function generateResize(configData, url) {
      var _this = this;

      var uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var iframe = document.getElementById("3DSIframe");
      var ipcIframe = document.getElementById('IPCIFrame' + uniqueId);
      var iframeInner = iframe.contentDocument.getElementById('3DSIframeInner');
      iframeInner.contentDocument.body.appendChild(loaderImg.generate());
      iFrameResize({
        checkOrigin: false,
        heightCalculationMethod: 'taggedElement',
        warningTimeout: 30000,
        scrolling: true,
        onMessage: function onMessage(data) {
          if (data.message.hasOwnProperty('event')) {
            switch (data.message.event) {
              case 'loading-finish':
                ipcIframe.src = iframe.contentDocument.getElementById('3DSIframeInner').contentWindow.location.href;
                break;

              case 'url-redirect':
                var formElement = document.getElementById('IPCForm');
                formElement.parentNode.removeChild(formElement);
                var paymentForm = new FormGenerator_FormGenerator();
                paymentForm.setProperties(data.message.data.parameters);
                paymentForm.setTarget('IPCIFrame' + uniqueId);
                paymentForm.setAction(data.message.data.action);
                paymentForm.setName('IPCForm');
                paymentForm.setId('IPCForm');
                ipcIframe.parentNode.appendChild(paymentForm.generate());
                document.IPCForm.submit();
                IframeModalGenerator.closeAction();
                break;

              case 'success-indicator':
                ipcIframe.contentWindow.postMessage({
                  type: 'payment-action',
                  data: 'process3DSComplete'
                }, url);
                IframeModalGenerator.closeAction();
                break;

              default:
                console.error('IFrm event "' + data.message.event + '" not recognized. Element id: ' + data.iframe.id);
                break;
            }
          }
        }
      }, iframeInner);
      var closeBtn = iframe.contentDocument.getElementById('myposCheckoutModalClose');

      closeBtn.onclick = function () {
        ipcIframe.src = iframe.hasAttribute('data-close-url') ? iframe.getAttribute('data-close-url') : "https://mypos.com/vmp/checkout";

        _this.closeAction();

        if (configData && configData.onPaymentStopped !== undefined && configData.onPaymentStopped instanceof Function) {
          configData.onPaymentStopped();
        }
      };
    }
  }]);

  return IframeModalGeneratorClass;
}();

var IframeModalGenerator = new IframeModalGenerator_IframeModalGeneratorClass();
// CONCATENATED MODULE: ./src/modules/classes/IframeResize.js



var IframeResize = {
  init: function init(configData, url) {
    var uniqueId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return new Promise(function (resolve, reject) {
      var ipcIFrame = document.getElementById('IPCIFrame' + uniqueId);
      var iframe;
      iFrameResize({
        checkOrigin: false,
        heightCalculationMethod: 'taggedElement',
        warningTimeout: 30000,
        onMessage: function onMessage(data) {
          if (data.message.hasOwnProperty('event')) {
            switch (data.message.event) {
              case '3ds':
                IframeModalGenerator.generateBackdropIframe();
                setTimeout(function () {
                  IframeModalGenerator.generateModalBackDropContent();
                  setTimeout(function () {
                    IframeModalGenerator.generateResize(configData, url, uniqueId);
                    var messageData = data.message.data.parameters;
                    var tdsForm = new FormGenerator_FormGenerator();
                    tdsForm.setAction(data.message.data.action);
                    tdsForm.setTarget('3DSIframeInner');
                    tdsForm.setId('3dsForm');
                    tdsForm.setName('downloadForm');
                    tdsForm.setProperties({
                      PaReq: messageData.strPaReq,
                      TermUrl: messageData.TermUrl,
                      MD: messageData.MD
                    });
                    iframe = document.getElementById("3DSIframe");

                    if (messageData.hasOwnProperty('close3DSIframeUrl')) {
                      iframe.setAttribute('data-close-url', messageData.close3DSIframeUrl);
                    }

                    iframe.contentDocument.body.appendChild(tdsForm.generate());
                    iframe.contentDocument[tdsForm.getName()].submit();
                  }, 50);
                }, 50);
                break;

              case '3ds2':
                IframeModalGenerator.generateBackdropIframe();
                setTimeout(function () {
                  IframeModalGenerator.generateModalBackDropContent();
                  setTimeout(function () {
                    IframeModalGenerator.generateResize(configData, url, uniqueId);
                    var tds2Form = new FormGenerator_FormGenerator();
                    tds2Form.setAction(data.message.data.action);
                    tds2Form.setTarget('3DSIframeInner');
                    tds2Form.setId('3dsForm');
                    tds2Form.setName('downloadForm');
                    tds2Form.setProperties({
                      creq: data.message.data.parameters.challengeRequest
                    });
                    iframe = document.getElementById("3DSIframe");

                    if (data.message.data.parameters.hasOwnProperty('close3DSIframeUrl')) {
                      iframe.setAttribute('data-close-url', data.message.data.parameters.close3DSIframeUrl);
                    }

                    iframe.contentDocument.body.appendChild(tds2Form.generate());
                    iframe.contentDocument[tds2Form.getName()].submit();
                  }, 50);
                }, 50);
                break;

              case 'tds':
                IframeModalGenerator.generateBackdropIframe();
                setTimeout(function () {
                  IframeModalGenerator.generateModalBackDropContent();
                  setTimeout(function () {
                    IframeModalGenerator.generateResize(configData, url, uniqueId);
                    var messageData = data.message.data.parameters;
                    var tdsForm = new FormGenerator_FormGenerator();
                    tdsForm.setAction(data.message.data.action);
                    tdsForm.setTarget('3DSIframeInner');
                    tdsForm.setId('3dsForm');
                    tdsForm.setName('downloadForm');
                    tdsForm.setProperties({
                      data_packet: messageData.data_packet,
                      return_url: messageData.return_url,
                      source: 4
                    });
                    iframe = document.getElementById("3DSIframe");

                    if (messageData.hasOwnProperty('close3DSIframeUrl')) {
                      iframe.setAttribute('data-close-url', messageData.close3DSIframeUrl);
                    }

                    iframe.contentDocument.body.appendChild(tdsForm.generate());
                    iframe.contentDocument[tdsForm.getName()].submit();
                  }, 50);
                }, 50);
                break;

              case 'url-page-redirect':
                window.location.href = data.message.data.action;
                break;

              case 'loading-finish':
                document.getElementById("myposCheckoutLoadingComponent" + uniqueId).style.display = "none";
                ipcIFrame.style.display = "block";
                resolve();
                break;

              case 'push-message':
                if (configData && configData.onMessageReceived !== undefined && configData.onMessageReceived instanceof Function) {
                  var message = data.message.hasOwnProperty('data') ? data.message.data : {};
                  configData.onMessageReceived(message);
                }

                return;

              case 'payment-stop':
                if (configData && configData.onPaymentStopped !== undefined && configData.onPaymentStopped instanceof Function) {
                  configData.onPaymentStopped();
                }

                return;

              case 'payment-start':
                if (configData && configData.onPaymentStarted !== undefined && configData.onPaymentStarted instanceof Function) {
                  configData.onPaymentStarted();
                }

                return;

              case 'google-pay-success':
                if (configData && configData.onSuccess !== undefined && configData.onSuccess instanceof Function) {
                  var _message = data.message.hasOwnProperty('data') ? data.message.data : {};

                  configData.onSuccess(_message);
                }

                return;

              case 'google-pay-error':
                if (configData && configData.onDecline !== undefined && configData.onDecline instanceof Function) {
                  configData.onDecline(data);
                }

                return;

              case 'success':
                if (configData && configData.onSuccess !== undefined && configData.onSuccess instanceof Function) {
                  var _message2 = data.message.hasOwnProperty('data') ? data.message.data : {};

                  configData.onSuccess(_message2);
                }

                return;

              case 'error':
                if (configData && configData.onError !== undefined && configData.onError instanceof Function) {
                  configData.onError(data);
                }

                reject();
                break;

              default:
                console.error('IFrm event "' + data.message.event + '" not recognized. Element id: ' + data.iframe.id);
                break;
            }
          }
        }
      }, ipcIFrame);
    });
  }
};
// CONCATENATED MODULE: ./src/config.js
var defaultData = {
  IPCVersion: '1.4',
  PaymentParametersRequired: 3,
  IPCLanguage: 'en',
  Source: "myPOS embedded checkout",
  Note: "myPOS embedded checkout "
};
var mandatoryData = {
  Embedded: 1,
  URL: window.location.href
};
var mandatoryDataForm = {
  EmbeddedForm: 1
};
var defaultDataPurchase = {
  CardTokenRequest: 0,
  PaymentMethod: 3
};
var mandatoryDataPurchase = {
  IPCmethod: 'IPCPurchase'
};
var defaultDataPreAuthorization = {};
var mandatoryDataPreAuthorization = {
  IPCmethod: 'IPCPreAuthorization'
};
// CONCATENATED MODULE: ./src/modules/AbstractModule.js


function AbstractModule_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AbstractModule_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AbstractModule_ownKeys(Object(source), true).forEach(function (key) { AbstractModule_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AbstractModule_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AbstractModule_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function AbstractModule_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AbstractModule_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function AbstractModule_createClass(Constructor, protoProps, staticProps) { if (protoProps) AbstractModule_defineProperties(Constructor.prototype, protoProps); if (staticProps) AbstractModule_defineProperties(Constructor, staticProps); return Constructor; }






var AbstractModule_AbstractModule = function () {
  function AbstractModule() {
    AbstractModule_classCallCheck(this, AbstractModule);

    if ((this instanceof AbstractModule ? this.constructor : void 0) === AbstractModule) {
      throw new TypeError("Cannot create object of AbstractModule");
    }
  }

  AbstractModule_createClass(AbstractModule, [{
    key: "_prepareParametersForRequest",
    value: function _prepareParametersForRequest(parameters) {
      if (parameters.cartItems !== undefined && parameters.cartItems.length > 0) {
        parameters.cartItems.map(function (item, index) {
          var article = item.article,
              price = item.price,
              currency = item.currency,
              quantity = item.quantity;

          if (article !== undefined) {
            parameters["Article_".concat(index + 1)] = article;
          }

          if (quantity !== undefined) {
            parameters["Quantity_".concat(index + 1)] = quantity;
          }

          if (price !== undefined) {
            parameters["Price_".concat(index + 1)] = price;
          }

          if (currency !== undefined) {
            parameters["Currency_".concat(index + 1)] = currency;
          }

          if (price !== undefined && quantity !== undefined) {
            parameters["Amount_".concat(index + 1)] = price * quantity;
          }
        });
        parameters.cartItems = parameters.cartItems.length;
      }

      if (_typeof(parameters.embeddedDesign) === 'object') {
        Object.keys(parameters.embeddedDesign).map(function (index) {
          parameters["EmbeddedDesign_".concat(index)] = parameters.embeddedDesign[index];
        });
        delete parameters.embeddedDesign;
      }

      return parameters;
    }
  }, {
    key: "init",
    value: function init(elementId, parameters) {
      var _this = this;

      var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var defaultDataModule = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var mandatoryDataModule = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var designParameters = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      return new Promise(function (resolve, reject) {
        if (parameters === undefined) {
          console.error("Error: Missing parameters object (sid, walletNumber, amount, currency, urlNotify, etc.!");
          reject();
        }

        var element = document.getElementById(elementId);

        if (element === null) {
          console.error("Error: Element with id=\"".concat(elementId, "\" not found!"));
          reject();
        }

        element.appendChild(loaderImg.generate());
        element.appendChild(IframeGenerator.generate());
        IframeResize.init(configData).then(function () {
          resolve();
        })["catch"](function () {
          reject();
        });
        var moduleForm = new FormGenerator_FormGenerator();

        if (_typeof(designParameters) === 'object' && Object.keys(designParameters).length > 0) {
          parameters.embeddedDesign = designParameters;
        }

        moduleForm.setProperties(_this._prepareParametersForRequest(parameters));
        moduleForm.setDefaultProperties(AbstractModule_objectSpread(AbstractModule_objectSpread({}, defaultData), defaultDataModule));
        moduleForm.setMandatoryProperties(AbstractModule_objectSpread(AbstractModule_objectSpread({}, mandatoryData), mandatoryDataModule));
        moduleForm.setTarget('IPCIFrame');
        var isSandbox = configData.isSandbox;

        if (isSandbox !== undefined && isSandbox) {
          moduleForm.setAction("https://mypos.com/vmp/checkout-test");
        } else if (configData.ipc_url !== undefined && configData.ipc_url.length > 0) {
          moduleForm.setAction(configData.ipc_url);
        } else {
          moduleForm.setAction("https://mypos.com/vmp/checkout");
        }

        moduleForm.setName('IPCForm');
        moduleForm.setId('IPCForm');
        element.appendChild(moduleForm.generate());
        document.IPCForm.submit();
      });
    }
  }]);

  return AbstractModule;
}();
// CONCATENATED MODULE: ./src/modules/Purchase.js


function Purchase_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Purchase_typeof = function _typeof(obj) { return typeof obj; }; } else { Purchase_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Purchase_typeof(obj); }

function Purchase_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Purchase_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Purchase_createClass(Constructor, protoProps, staticProps) { if (protoProps) Purchase_defineProperties(Constructor.prototype, protoProps); if (staticProps) Purchase_defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (Purchase_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var Purchase_PurchaseClass = function (_AbstractModule) {
  _inherits(PurchaseClass, _AbstractModule);

  var _super = _createSuper(PurchaseClass);

  function PurchaseClass() {
    Purchase_classCallCheck(this, PurchaseClass);

    return _super.apply(this, arguments);
  }

  Purchase_createClass(PurchaseClass, [{
    key: "init",
    value: function init(elementId, parameters) {
      var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return _get(_getPrototypeOf(PurchaseClass.prototype), "init", this).call(this, elementId, parameters, configData, defaultDataPurchase, mandatoryDataPurchase, designParameters);
    }
  }]);

  return PurchaseClass;
}(AbstractModule_AbstractModule);

var Purchase = new Purchase_PurchaseClass();
// CONCATENATED MODULE: ./src/modules/methods/AbstractMethod.js
function AbstractMethod_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractMethod = function AbstractMethod() {
  var uniqueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  AbstractMethod_classCallCheck(this, AbstractMethod);

  if ((this instanceof AbstractMethod ? this.constructor : void 0) === AbstractMethod) {
    throw new TypeError("Cannot create object of AbstractModule");
  }

  this.ipcIFrame = document.getElementById('IPCIFrame' + uniqueId);
};
// CONCATENATED MODULE: ./src/modules/methods/Payment.js
function Payment_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Payment_typeof = function _typeof(obj) { return typeof obj; }; } else { Payment_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Payment_typeof(obj); }

function Payment_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Payment_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Payment_createClass(Constructor, protoProps, staticProps) { if (protoProps) Payment_defineProperties(Constructor.prototype, protoProps); if (staticProps) Payment_defineProperties(Constructor, staticProps); return Constructor; }

function Payment_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Payment_setPrototypeOf(subClass, superClass); }

function Payment_setPrototypeOf(o, p) { Payment_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Payment_setPrototypeOf(o, p); }

function Payment_createSuper(Derived) { var hasNativeReflectConstruct = Payment_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Payment_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Payment_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Payment_possibleConstructorReturn(this, result); }; }

function Payment_possibleConstructorReturn(self, call) { if (call && (Payment_typeof(call) === "object" || typeof call === "function")) { return call; } return Payment_assertThisInitialized(self); }

function Payment_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Payment_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function Payment_getPrototypeOf(o) { Payment_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Payment_getPrototypeOf(o); }


var Payment = function (_AbstractMethod) {
  Payment_inherits(Payment, _AbstractMethod);

  var _super = Payment_createSuper(Payment);

  function Payment() {
    var _this;

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    Payment_classCallCheck(this, Payment);

    _this = _super.call(this, uniqueId);

    if (url !== null) {
      _this.url = url;
    }

    return _this;
  }

  Payment_createClass(Payment, [{
    key: "processPayment",
    value: function processPayment() {
      var url = this.url !== undefined ? this.url : "https://mypos.com/vmp/checkout-test";
      this.ipcIFrame.contentWindow.postMessage({
        type: 'payment-action',
        data: 'process'
      }, url);
    }
  }]);

  return Payment;
}(AbstractMethod);
// CONCATENATED MODULE: ./src/modules/PreAuthorization.js


function PreAuthorization_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { PreAuthorization_typeof = function _typeof(obj) { return typeof obj; }; } else { PreAuthorization_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return PreAuthorization_typeof(obj); }

function PreAuthorization_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PreAuthorization_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PreAuthorization_createClass(Constructor, protoProps, staticProps) { if (protoProps) PreAuthorization_defineProperties(Constructor.prototype, protoProps); if (staticProps) PreAuthorization_defineProperties(Constructor, staticProps); return Constructor; }

function PreAuthorization_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { PreAuthorization_get = Reflect.get; } else { PreAuthorization_get = function _get(target, property, receiver) { var base = PreAuthorization_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return PreAuthorization_get(target, property, receiver || target); }

function PreAuthorization_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = PreAuthorization_getPrototypeOf(object); if (object === null) break; } return object; }

function PreAuthorization_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) PreAuthorization_setPrototypeOf(subClass, superClass); }

function PreAuthorization_setPrototypeOf(o, p) { PreAuthorization_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return PreAuthorization_setPrototypeOf(o, p); }

function PreAuthorization_createSuper(Derived) { var hasNativeReflectConstruct = PreAuthorization_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = PreAuthorization_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = PreAuthorization_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return PreAuthorization_possibleConstructorReturn(this, result); }; }

function PreAuthorization_possibleConstructorReturn(self, call) { if (call && (PreAuthorization_typeof(call) === "object" || typeof call === "function")) { return call; } return PreAuthorization_assertThisInitialized(self); }

function PreAuthorization_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PreAuthorization_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function PreAuthorization_getPrototypeOf(o) { PreAuthorization_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return PreAuthorization_getPrototypeOf(o); }




var PreAuthorization_PreAuthorizationClass = function (_AbstractModule) {
  PreAuthorization_inherits(PreAuthorizationClass, _AbstractModule);

  var _super = PreAuthorization_createSuper(PreAuthorizationClass);

  function PreAuthorizationClass() {
    PreAuthorization_classCallCheck(this, PreAuthorizationClass);

    return _super.apply(this, arguments);
  }

  PreAuthorization_createClass(PreAuthorizationClass, [{
    key: "init",
    value: function init(elementId, parameters) {
      var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return PreAuthorization_get(PreAuthorization_getPrototypeOf(PreAuthorizationClass.prototype), "init", this).call(this, elementId, parameters, configData, defaultDataPreAuthorization, mandatoryDataPreAuthorization, designParameters);
    }
  }]);

  return PreAuthorizationClass;
}(AbstractModule_AbstractModule);

var PreAuthorization = new PreAuthorization_PreAuthorizationClass();
// CONCATENATED MODULE: ./src/modules/SelfCheckout.js
function SelfCheckout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelfCheckout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SelfCheckout_createClass(Constructor, protoProps, staticProps) { if (protoProps) SelfCheckout_defineProperties(Constructor.prototype, protoProps); if (staticProps) SelfCheckout_defineProperties(Constructor, staticProps); return Constructor; }





var SelfCheckout_SelfCheckoutClass = function () {
  function SelfCheckoutClass() {
    SelfCheckout_classCallCheck(this, SelfCheckoutClass);
  }

  SelfCheckout_createClass(SelfCheckoutClass, [{
    key: "init",
    value: function init(elementId, url, configData) {
      var uniqueId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      return new Promise(function (resolve, reject) {
        var element = document.getElementById(elementId);

        if (element === null) {
          console.error("Error: Element with id=\"".concat(elementId, "\" not found!"));
          reject();
        }

        element.appendChild(loaderImg.generate(uniqueId));
        element.appendChild(IframeGenerator.generate(url, uniqueId));
        IframeResize.init(configData, url, uniqueId).then(function () {
          resolve();
        })["catch"](function () {
          reject();
        });
      });
    }
  }]);

  return SelfCheckoutClass;
}();

var SelfCheckout = new SelfCheckout_SelfCheckoutClass();
// CONCATENATED MODULE: ./src/modules/classes/Request.js


function Request_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Request_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Request_ownKeys(Object(source), true).forEach(function (key) { Request_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Request_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function Request_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Request_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Request = function Request() {
  var _this = this;

  Request_classCallCheck(this, Request);

  Request_defineProperty(this, "postData", _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    var url,
        data,
        formdata,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
            data = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            formdata = new FormData();
            Object.keys(data).map(function (key) {
              formdata.append(key, data[key]);
            });
            _context.next = 6;
            return fetch(url, {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              redirect: "follow",
              body: formdata,
              referrerPolicy: "no-referrer"
            });

          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.json());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  Request_defineProperty(this, "ipcCall", function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(ipcMethod) {
      var data,
          _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              data = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              return _context3.abrupt("return", _this.postData("https://mypos.com/vmp/checkout", Request_objectSpread(Request_objectSpread({}, data), {
                IPCMethod: ipcMethod,
                OutputFormat: 'json'
              })).then(function () {
                var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(result) {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(result.Status === undefined || result.Status === null || parseInt(result.Status) !== 0)) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return", Promise.reject(result));

                        case 2:
                          return _context2.abrupt("return", result);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/* harmony default export */ var classes_Request = (new Request());
// CONCATENATED MODULE: ./src/modules/classes/ApplePayButtonGenerator.js
function ApplePayButtonGenerator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ApplePayButtonGenerator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ApplePayButtonGenerator_createClass(Constructor, protoProps, staticProps) { if (protoProps) ApplePayButtonGenerator_defineProperties(Constructor.prototype, protoProps); if (staticProps) ApplePayButtonGenerator_defineProperties(Constructor, staticProps); return Constructor; }



var ApplePayButtonGenerator_ApplePayButtonGeneratorClass = function () {
  function ApplePayButtonGeneratorClass() {
    ApplePayButtonGenerator_classCallCheck(this, ApplePayButtonGeneratorClass);
  }

  ApplePayButtonGenerator_createClass(ApplePayButtonGeneratorClass, [{
    key: "generate",
    value: function generate(configData) {
      return _jsxCreateElement("div", {
        className: "apple-pay-button apple-pay-button-text-plain \n            ".concat(configData.theme === 'light' ? 'apple-pay-button-white-with-text' : 'apple-pay-button-with-text'),
        id: 'ckoApplePay',
        lang: configData.language || 'en'
      });
    }
  }]);

  return ApplePayButtonGeneratorClass;
}();

var ApplePayButtonGenerator = new ApplePayButtonGenerator_ApplePayButtonGeneratorClass();
// CONCATENATED MODULE: ./src/modules/classes/StylesGenerator.js
function StylesGenerator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StylesGenerator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function StylesGenerator_createClass(Constructor, protoProps, staticProps) { if (protoProps) StylesGenerator_defineProperties(Constructor.prototype, protoProps); if (staticProps) StylesGenerator_defineProperties(Constructor, staticProps); return Constructor; }



var StylesGenerator_StylesGeneratorClass = function () {
  function StylesGeneratorClass() {
    StylesGenerator_classCallCheck(this, StylesGeneratorClass);
  }

  StylesGenerator_createClass(StylesGeneratorClass, [{
    key: "getCssContentByName",
    value: function getCssContentByName(fileName) {
      return _jsxCreateElement("style", null, " ", __webpack_require__(57)("./".concat(fileName)).toString(), " ");
    }
  }]);

  return StylesGeneratorClass;
}();

var StylesGenerator = new StylesGenerator_StylesGeneratorClass();
// CONCATENATED MODULE: ./src/modules/ApplePayButton.js


function ApplePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function ApplePayButton_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { ApplePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { ApplePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ApplePayButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ApplePayButton_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var CARD_BRAND_MASTERCARD = 'M';
var CARD_BRAND_VISA = 'V';
var CARD_BRAND_JCB = 'J';
var CARD_BRAND_BANCONTACT = 'C';
var CARD_BRAND_AMEX = 'X';

var ApplePayButton_ApplePayButtonClass = function ApplePayButtonClass() {
  var _this = this;

  ApplePayButton_classCallCheck(this, ApplePayButtonClass);

  ApplePayButton_defineProperty(this, "setup", false);

  ApplePayButton_defineProperty(this, "_configData", {});

  ApplePayButton_defineProperty(this, "_sessionData", {});

  ApplePayButton_defineProperty(this, "_paymentSessionToken", '');

  ApplePayButton_defineProperty(this, "merchantIdentifier", 'merchant.mypos.eu');

  ApplePayButton_defineProperty(this, "getAllowedCardNetworks", function () {
    var allowedCardNetworks = [];

    if (_this._sessionData && _this._sessionData.cardScheme.includes(CARD_BRAND_VISA)) {
      allowedCardNetworks.push('visa');
      allowedCardNetworks.push('vPay');
    }

    if (_this._sessionData && _this._sessionData.cardScheme.includes(CARD_BRAND_MASTERCARD)) {
      allowedCardNetworks.push('masterCard');
      allowedCardNetworks.push('maestro');
    }

    return allowedCardNetworks;
  });

  ApplePayButton_defineProperty(this, "validateApplePaySessionCallback", function (validationUrl, merchantIdentifier) {
    return classes_Request.ipcCall('IPCApplePayDomainSession', {
      Url: validationUrl,
      Domain: window.location.hostname,
      MerchantIdentifier: merchantIdentifier,
      PaymentSessionToken: _this._paymentSessionToken
    }).then(function (res) {
      return JSON.parse(res.Content);
    });
  });

  ApplePayButton_defineProperty(this, "onProcessPayment", function (event) {
    return classes_Request.ipcCall('IPCApplePayProcess', {
      ApplePayToken: JSON.stringify(event.token),
      PaymentSessionToken: _this._paymentSessionToken
    });
  });

  ApplePayButton_defineProperty(this, "_handleApplePayEvents", function (appleSession) {
    appleSession.onvalidatemerchant = function (event) {
      _this.setup = false;

      _this.validateApplePaySessionCallback(event.validationURL, _this.merchantIdentifier).then(function (result) {
        return appleSession.completeMerchantValidation(result);
      })["catch"](function (err) {
        if (_this._configData.onDecline !== undefined && _this._configData.onDecline instanceof Function) {
          _this._configData.onDecline(err);
        }

        appleSession.abort();
      });
    };

    appleSession.onpaymentauthorized = function (event) {
      _this.onProcessPayment(event.payment).then(function (data) {
        if (_this._configData.onSuccess !== undefined && _this._configData.onSuccess instanceof Function) {
          _this._configData.onSuccess(data);
        }

        appleSession.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      })["catch"](function (data) {
        if (_this._configData.onDecline !== undefined && _this._configData.onDecline instanceof Function) {
          _this._configData.onDecline(data);
        }

        appleSession.completePayment(window.ApplePaySession.STATUS_FAILURE);
      });
    };
  });

  ApplePayButton_defineProperty(this, "_startApplePaySession", function (config) {
    var applePaySession = new window.ApplePaySession(6, config);

    _this._handleApplePayEvents(applePaySession);

    applePaySession.begin();
  });

  ApplePayButton_defineProperty(this, "onPayButtonClick", function () {
    _this._startApplePaySession({
      currencyCode: _this._sessionData.currency,
      countryCode: _this._sessionData.merchantCountry.toUpperCase(),
      merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
      supportedNetworks: _this.getAllowedCardNetworks(),
      requiredBillingContactFields: _this._configData.requiredFields || [],
      total: {
        label: _this._configData.merchantName,
        amount: _this._sessionData.amount,
        type: 'final'
      }
    });
  });

  ApplePayButton_defineProperty(this, "setUp", function () {
    window.ApplePaySession.canMakePaymentsWithActiveCard(_this.merchantIdentifier).then(function (canMakePayments) {
      if (!canMakePayments && window.ApplePaySession.openPaymentSetup) {
        _this.setup = true;
      }
    });
  });

  ApplePayButton_defineProperty(this, "init", function () {
    var _ref = ApplePayButton_asyncToGenerator(regeneratorRuntime.mark(function _callee(elementId, sessionToken, configData) {
      var iframeElement, element, button;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (window.ApplePaySession) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", Promise.reject({
                'message': 'Apple pay not supported with this browser/device!'
              }));

            case 2:
              _this._configData = configData;
              _this._paymentSessionToken = sessionToken;
              _this._sessionData = _this._extractDataFromToken(sessionToken);
              iframeElement = IframeGenerator.generate(null, '', 40);

              _this.setUp();

              element = document.getElementById(elementId);
              element.appendChild(iframeElement);
              iframeElement.contentDocument.body.style.margin = '0px';
              iframeElement.contentDocument.head.appendChild(StylesGenerator.getCssContentByName('applePay.css'));
              button = ApplePayButtonGenerator.generate(_this._configData);

              button.onclick = function () {
                _this.onPayButtonClick();
              };

              iframeElement.contentDocument.body.appendChild(button);
              iframeElement.style.display = "block";
              return _context.abrupt("return", Promise.resolve(_this._sessionData));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());

  ApplePayButton_defineProperty(this, "_extractDataFromToken", function (sessionToken) {
    var infoData = JSON.parse(atob(sessionToken)).info.split("-");
    var cardSchemes = [];

    for (var i = 0; i < infoData[1].length; i++) {
      cardSchemes.push(infoData[1].charAt(i));
    }

    var sessToken = {
      SID: infoData[0],
      cardScheme: cardSchemes,
      isAppleAvailable: infoData[2],
      isGoogleAvailable: infoData[3],
      currency: infoData[4],
      amount: infoData[5],
      merchantCountry: infoData[6]
    };
    return sessToken;
  });
};

var ApplePayButton = new ApplePayButton_ApplePayButtonClass();
// CONCATENATED MODULE: ./src/modules/GooglePayButton.js


function GooglePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function GooglePayButton_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { GooglePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { GooglePayButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function GooglePayButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GooglePayButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function GooglePayButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) GooglePayButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) GooglePayButton_defineProperties(Constructor, staticProps); return Constructor; }

function GooglePayButton_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var GooglePayButton_GooglePayButtonClass = function () {
  function GooglePayButtonClass() {
    GooglePayButton_classCallCheck(this, GooglePayButtonClass);

    GooglePayButton_defineProperty(this, "_configData", {});

    GooglePayButton_defineProperty(this, "_sessionData", {});

    GooglePayButton_defineProperty(this, "_paymentSessionToken", '');

    GooglePayButton_defineProperty(this, "_extractDataFromToken", function (sessionToken) {
      var infoData = JSON.parse(atob(sessionToken)).info.split("-");
      var cardSchemes = [];

      for (var i = 0; i < infoData[1].length; i++) {
        cardSchemes.push(infoData[1].charAt(i));
      }

      var sessToken = {
        SID: infoData[0],
        cardScheme: cardSchemes,
        isAppleAvailable: infoData[2],
        isGoogleAvailable: infoData[3],
        currency: infoData[4],
        amount: infoData[5]
      };
      return sessToken;
    });
  }

  GooglePayButton_createClass(GooglePayButtonClass, [{
    key: "getIPCUrl",
    value: function getIPCUrl() {
      return this._configData.isSandbox !== undefined && this._configData.isSandbox ? "https://mypos.com/vmp/checkout-test" : "https://mypos.com/vmp/checkout";
    }
  }, {
    key: "init",
    value: function () {
      var _init = GooglePayButton_asyncToGenerator(regeneratorRuntime.mark(function _callee(elementId, sessionToken, configData) {
        var _this = this;

        var url, iframeElement, element;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._sessionData = this._extractDataFromToken(sessionToken);
                this._paymentSessionToken = sessionToken;
                this._configData = configData;
                url = this.getIPCUrl() + '/googlePayIframe?sessionToken=' + sessionToken + '&configData=' + btoa(JSON.stringify(this._configData));
                iframeElement = IframeGenerator.generate(url, '', 60);
                element = document.getElementById(elementId);
                element.appendChild(iframeElement);
                iframeElement.style.display = "block";
                iframeElement.style.width = "100%";
                iframeElement.style.height = "60px!important";
                IframeResize.init(configData, url).then(function () {
                  Promise.resolve(_this._sessionData);
                })["catch"](function () {
                  Promise.reject({
                    'message': 'Failed to load google pay button!'
                  });
                });
                return _context.abrupt("return", Promise.resolve(this._sessionData));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x, _x2, _x3) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return GooglePayButtonClass;
}();

var GooglePayButton = new GooglePayButton_GooglePayButtonClass();
// CONCATENATED MODULE: ./src/index.js


function src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function src_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { src_ownKeys(Object(source), true).forEach(function (key) { src_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function src_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function createPayment(elementId, parameters) {
  var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    Purchase.init(elementId, parameters, configData, designParameters).then(function () {
      resolve(new Payment());
    })["catch"](function () {
      reject();
    });
  });
}
function createPaymentForm(elementId, parameters) {
  var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    Purchase.init(elementId, src_objectSpread(src_objectSpread({}, parameters), mandatoryDataForm), configData, designParameters).then(function () {
      resolve(new Payment());
    })["catch"](function () {
      reject();
    });
  });
}
function createPreAuthorization(elementId, parameters) {
  var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    PreAuthorization.init(elementId, parameters, configData, designParameters).then(function () {
      resolve(new Payment());
    })["catch"](function () {
      reject();
    });
  });
}
function createPreAuthorizationForm(elementId, parameters) {
  var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var designParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    PreAuthorization.init(elementId, src_objectSpread(src_objectSpread({}, parameters), mandatoryDataForm), configData, designParameters).then(function () {
      resolve(new Payment());
    })["catch"](function () {
      reject();
    });
  });
}
function createSelfCheckoutPayment(elementId, url) {
  var configData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    var uniqueId = '_' + elementId;
    SelfCheckout.init(elementId, url, configData, uniqueId).then(function () {
      resolve(new Payment(url, uniqueId));
    })["catch"](function () {
      reject();
    });
  });
}
function createApplePayButton(_x, _x2, _x3) {
  return _createApplePayButton.apply(this, arguments);
}

function _createApplePayButton() {
  _createApplePayButton = src_asyncToGenerator(regeneratorRuntime.mark(function _callee(elementId, sessionToken, configData) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", ApplePayButton.init(elementId, sessionToken, configData));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createApplePayButton.apply(this, arguments);
}

function createGooglePayButton(_x4, _x5, _x6) {
  return _createGooglePayButton.apply(this, arguments);
}

function _createGooglePayButton() {
  _createGooglePayButton = src_asyncToGenerator(regeneratorRuntime.mark(function _callee2(elementId, sessionToken, configData) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", GooglePayButton.init(elementId, sessionToken, configData));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createGooglePayButton.apply(this, arguments);
}

var IS_APPLE_PAY_AVAILABLE = window.ApplePaySession;
var IPC_URL = "https://mypos.com/vmp/checkout";

/***/ })
/******/ ]);
});